import Vue from 'vue'
import VueGtag from "vue-gtag";
import lodash from 'lodash'

import Home from "./components/Home.vue";
import Questionnaire from "./components/Questionnaire.vue";
import Loading from "./components/Loading.vue";
import ResultPart from "./components/ResultPart.vue";
import Share from "./components/Share.vue";

import results from './results.json'
import {gsap} from "gsap";

Vue.use(lodash)
Vue.use(VueGtag, {
    config: { id: "G-5SCFKXDMSF" } // 正式用
    // config: { id: "G-HG84VYEN6R" }
});
const app = new Vue({
    el: '#app',
    data: {
        loading_show: false,
        is_show: 'home',
        auth: false,
        results:results,
        result:[],
        uid: null,
        path: process.env.MIX_APP_URL+'/ben/npm/images/',
    },
    components:{
        'home'          : Home,
        'questionnaire' : Questionnaire,
        'loading'       : Loading,
        'result-part'   : ResultPart,
        'share'         : Share,
    },
    created() {
        // 設定預設的 view
        this.setDefaultView();

        this.auth = document.querySelector('meta[name="auth"]').content
        let answers = document.querySelector('meta[name="answers"]').content
        let index   = document.querySelector('meta[name="index"]').content
        this.updateResult(answers, index)

        this.uid = document.querySelector('meta[name="uid"]').content
    },
    mounted() {
        // 預載圖片
        const image = new Image();
        image.src = process.env.MIX_APP_URL+'/ben/npm/images/loading.gif'
    },
    methods:{
        setDefaultView: function () {
            this.is_show = document.querySelector('meta[name="default_view"]').content
        },
        updateResult: function (answers, index) {

            this.result.index   = index
            this.result.answers = answers
            this.result.data    = this.getAnswer(answers)
            this.result.song    = _.get(this.result.data, 'songs['+index+']');

            if(this.result.data !== undefined){
                this.result.fatigue = _.random(this.result.data.fatigue_index[0], this.result.data.fatigue_index[1]);
            }else{
                this.result.fatigue = 1;
            }
        },
        getAnswer(answers){
            return _.filter(results, function(o) { return o.answers.includes(answers); })[0];
        },
        switchComponent: function (page) {
            this.is_show = page
        },
        showLoading: function () {
            this.loading_show = true
        },
        hideLoading: function () {
            this.loading_show = false
        },
        approachAnimate(){
            const t1 = gsap.timeline()
            t1.to('.rd-approach', {opacity:1, y: 0, duration:1.5, ease: "power3.out"})
        }
    }
}).$mount('#app');

